import React from "react";
import styled from "styled-components";
import RegistrationForm from "../components/RegistrationForm";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #e8f0fe;
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RegisterPage = () => {
  // Detect click outside province dropdown to close it
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector(".province-dropdown");
      if (dropdown && !dropdown.contains(event.target)) {
        // Close dropdown logic
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <PageContainer>
      <MainContent>
        <RegistrationForm />
      </MainContent>
    </PageContainer>
  );
};

export default RegisterPage;
